import type { FaireProductEntity } from "../../entity_types/product";

export const p_f5j6nt9555: FaireProductEntity = {
  token: "p_f5j6nt9555",
  type: "product",
  name: "Daza Bowl | Catchall Bowl | Centerpiece Bowl",
  brandToken: "b_kqbf429fct",
  brandName: "Fancy Concrete",
  imageUrl:
    "https://cdn.faire.com/fastly/8ae99b168de442ad0409ad1c025eaa60916b57206b14eca8b892b5691b6488ef.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8dc00947bb809506dd52697302894cd49a2f21e17a8c7990086d6a3fe59a2293.jpeg",
    "https://cdn.faire.com/fastly/d5962b9bbf432a3d2ac30b2cc6d3860beb790aa17062d1ad658d24bee27a2221.jpeg",
    "https://cdn.faire.com/fastly/0a1071ab0f89e5e4c7f799b69090a966a5b4e8f1a9f62d133337427fc4ed1699.jpeg",
    "https://cdn.faire.com/fastly/91817e1eb9fff9d4fe23251dc34b7487bc656e0b0ae641501f8f3ddbe325ebb9.jpeg",
    "https://cdn.faire.com/fastly/46fa531fe751f8b4a337a76076db8b77e2a4efd662196dc97cc17a0ff4b30b2a.jpeg",
    "https://cdn.faire.com/fastly/dec39ce248bb88eb7e6b5b8e406c030a9158a890f7f7781af18d333f9b3aceed.jpeg",
    "https://cdn.faire.com/fastly/56c526594b9d39152c89ae8cf26b7e2327cb368a9941e208dba214d6fc982259.jpeg",
    "https://cdn.faire.com/fastly/bdf809114bdc6ae650265cf6d4452fcac481bc67c0f3de44d406ed56f85d7afe.jpeg",
    "https://cdn.faire.com/fastly/5084e7f4abd0844802192a620e113a96da587346b83059cf182a81a2cb5a2a0e.jpeg",
    "https://cdn.faire.com/fastly/f41116b4ac947bfbdd61dce2e23a895cce8682c28ae97f67fd08083708f1d324.jpeg",
    "https://cdn.faire.com/fastly/d984416e9cf061e0839f719fb5c16ff1c70f6f8dbace4fac4e8a0cd2270759fa.jpeg",
  ],
  priceDollars: 22.8,
  description:
    "Daza - our versatile concrete bowl, ready to elevate your space with its timeless appeal. This stylish yet functional piece seamlessly transitions between decorative accents and a chic planter. Its smooth, minimalist design adds a touch of sophistication to any setting, whether it's displayed on a coffee table, shelf, or as a centerpiece. As a planter, it provides the perfect home for your favorite succulents, ferns, or floral arrangements, bringing a touch of greenery indoors.\n\n𝓜𝓮𝓶𝓸𝓶𝓻𝓮𝓲𝓮𝓷𝓹𝓸:\n• Bowl Diameter: 6 3/4\" \n• Tall: 2.3” \n\nEach concrete item is handmade from scratch, as concrete is made from natural materials it has certain unique characteristics, or air bubbles may occur and are not considered a fault. Please notice as the concrete is poured in different batches there may be a slight variation in colour and pattern. All items are cured and protected with a water resistant sealant.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:42.402Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
